<!-- Revise videos section start -->
<!-- <div class="SLV2-section-wrap lr-no-padding with-btm-border">
    <div class="SLV2-section-head-section">
        <h3 class="SLV2-section-heading">Revise videos</h3>
        <button class="SLV2-viewall-link">view all <i class="fa fa-angle-right"></i></button>
    </div>
    <div class="SLV2-video-slider-area">
        <carousel #myCarousel class="SLV2-video-carousel" [height]="235" [margin]="20" [cellWidth]="230">
            <div class="carousel-cell" *ngFor="let item of cardList">
                <app-video-card [cardTitle]="item.cardTitle"></app-video-card>
            </div>
        </carousel>
    </div> 
</div> -->
<!-- Revise videos section ended -->

<!-- Topic Summaries section start -->
<div class="SLV2-section-wrap lr-no-padding with-btm-border" *ngIf="topicCardList?.length > 0">
    <div class="SLV2-section-head-section">
        <h3 class="SLV2-section-heading">Topic Summaries</h3>
        <button class="SLV2-viewall-link" (click)="navigateToTopicsViewAll()" *ngIf="(storiesList?.length>0 || isMemoryCardsAvailable)&&topicCardList.length>4">view all <i class="fa fa-angle-right"></i></button>
    </div>
    <div class="row _slider-row SLV2-sm-gap SLV2-leading-zero-list">
        <ng-container *ngFor="let item of topicCardList let i = index">
        <div class="col-xl-3 col-lg-6 col-md-6 col-12" *ngIf="storiesList?.length > 0 || isMemoryCardsAvailable ? (i<4) : (i <= topicCardList.length)" >
            <div >
           <app-topic-summary-card [topicName]="item?.topicName" [flashcardData]="item" [allTopicsSummeryProgress]="allTopicsSummeryProgress" ></app-topic-summary-card>
            </div>
        </div>
    </ng-container>
    </div>
</div>
<!-- Topic Summaries section ended -->

<!-- when there is no stories -->
<ng-container *ngIf="topicCardList?.length <= 0 && storiesList?.length<=0">
    <app-no-content-card></app-no-content-card>
</ng-container>

<!-- end of there is no stories -->
<!-- stories banner section start -->
<div class="SLV2-section-wrap lr-no-padding with-btm-border" *ngIf="storiesList?.length>0 && isStoriesVisible()">
    <app-stories-banner-card class="center" [storiesList]="storiesList"></app-stories-banner-card>
</div>
<!-- stories banner section ended -->

<!-- My Bookmarks section start -->
<!-- <div class="SLV2-section-wrap lr-no-padding with-btm-border">
    <div class="SLV2-section-head-section">
        <h3 class="SLV2-section-heading">My Bookmarks</h3>
        <button class="SLV2-viewall-link">view all <i class="fa fa-angle-right"></i></button>
    </div>
    <div>
        <ngb-carousel #carousel class="singleCarousel" [interval]="5000" [pauseOnHover]="pauseOnHover" [pauseOnFocus]="pauseOnFocus">
            <ng-template ngbSlide>
                    <app-bookmark-card class="col-view"></app-bookmark-card>
            </ng-template>
            <ng-template ngbSlide>
                    <app-bookmark-card class="col-view"></app-bookmark-card>
            </ng-template>
            <ng-template ngbSlide>
                    <app-bookmark-card class="col-view"></app-bookmark-card>
            </ng-template>
            <ng-template ngbSlide>
                    <app-bookmark-card class="col-view"></app-bookmark-card>
            </ng-template>
        </ngb-carousel>
    </div>
</div> -->
<!-- My Bookmarks section ended -->


<!-- memory card section start -->
<div class="SLV2-section-wrap lr-no-padding" *ngIf="isMemoryCardsAvailable">
    <app-memory-banner-card [isMemoryCard]=true></app-memory-banner-card>
</div>
<!-- memory card section ended -->

